export const CHANGE_CURRENT_PAGE = 'DTGProducts/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'DTGProducts/CHANGE_PAGE_SIZE'
export const CREATE_DTG_PRODUCT = 'DTGProducts/CREATE'
export const FETCH_DTG_PRODUCT_LIST = 'DTGProducts/FETCH_LIST'
export const FETCH_DTG_PRODUCT_FOR_OPTIONS = 'DTGProducts/FETCH_FOR_OPTIONS'
export const REMOVE_DTG_PRODUCT = 'DTGProducts/REMOVE'
